import { useState } from "react";
import PayrollCompanyLayout from "../../../components/layouts/PayrollCompanyLayout";
import { Helmet } from "react-helmet-async";
import CustomTab from "../../../components/custom_tab/CustomTab";
import { OvertimeAndBonusTabColumns } from "../../../components/custom_tab/tabColumns";
import OvertimeView from "./views/OvertimeView";
import BonusView from "./views/BonusView";
import { useSearchParams } from "react-router-dom";
import { PERMISSIONS, useValidateUserPermissions } from "../../../helpers/usePermissionManager";

const OvertimeAndBonuses = () => {
	const hasPermission = useValidateUserPermissions(
		[PERMISSIONS.COMPANY_CONFIGS_WRITE, PERMISSIONS.COMPANY_CONFIGS_READ], 
		"OR"
	);
	const [searchParams] = useSearchParams();
	const [view, setView] = useState(
		searchParams.get("view") || "overtime"
	);
	
	return (<>
		{hasPermission && (
			<PayrollCompanyLayout>
				<Helmet>
					<title>Overtime & Bonuses | Company Flow</title>
				</Helmet>
				<h1 className="font-bold text-xl mb-8">Overtime & Bonuses</h1>
				<CustomTab
					view={view}
					setView={setView}
					tabColumns={OvertimeAndBonusTabColumns}
				>
					{view === "overtime" && <OvertimeView />}
					{view === "bonuses" && <BonusView />}
				</CustomTab>
			</PayrollCompanyLayout>
		)}
	</>);
};

export default OvertimeAndBonuses;
